export const subjects = [
  {
    name: 'русский язык',
    slug: 'russian',
    dativeName: 'русскому языку',
  },
  {
    name: 'математика',
    slug: 'mathematics',
    dativeName: 'математике',
  },
  {
    name: 'обществознание',
    slug: 'social',
    dativeName: 'обществознанию',
  },
  {
    name: 'биология',
    slug: 'biology',
    dativeName: 'биологии',
  },
  {
    name: 'информатика',
    slug: 'informatics',
    dativeName: 'информатике',
  },
  {
    name: 'физика',
    slug: 'physics',
    dativeName: 'физике',
  },
  {
    name: 'история',
    slug: 'history',
    dativeName: 'истории',
  },
  {
    name: 'английский язык',
    slug: 'english',
    dativeName: 'английскому языку',
  },
  {
    name: 'химия',
    slug: 'chemistry',
    dativeName: 'химии',
  },
  {
    name: 'литература',
    slug: 'literature',
    dativeName: 'литературе',
  },
]
